<template>
  <div id="GuestQRCodeDialog_main">
    <el-dialog
      title="門禁QR Code"
      :visible.sync="dialogVisible"
      width="20%"
      @close="closeDialog"
    >
      <div class="timeWrap">
        <p class="timeTitle">
          剩餘有效時間
        </p>
        <p
          v-if="mode === 1"
          class="mode mode1"
        >
          {{ showCountdown }}
        </p>
        <p
          v-if="mode === 2"
          class="mode mode2"
        >
          尚未生效
        </p>
        <p
          v-if="mode === 2"
          class="mode2_tip"
        >
          欲立即生效請按下方立即產生QR Code
        </p>
        <p
          v-if="mode === 3"
          class="mode mode3"
        >
          已失效
        </p>
      </div>
      <div
        v-loading="loading"
        class="qrcodeDiv"
      >
        <vue-qr
          :class="mode !== 1 ? 'opacityQrcode' : ''"
          :correct-level="3"
          :dot-scale="1"
          :logo-src="require('@/assets/img/GuestPrint/sphere-logo-BW.png')"
          :text="qrcodeData"
          :logo-background-color="'#fff'"
          :logo-margin="0"
          :logo-scale="0.3"
          :logo-corner-radius="40"
          :size="300"
        />
      </div>
      <div
        v-if="mode !== 3"
        class="periodWrap"
      >
        <p>門禁感應QR Code 有效期間</p>
        <p
          v-if="dialogVisible"
          class="period"
        >
          {{ data.startAt.slice(0,16) }} 至 {{ data.dueAt.slice(0,16) }}
        </p>
      </div>
      <el-button
        v-if="mode === 2"
        :disabled="!canClickButton"
        round
        @click="reacquireQRCode()"
      >
        立即產生QR Code
      </el-button>
      <el-button
        v-else
        :disabled="!canClickButton"
        round
        @click="reacquireQRCode()"
      >
        重新產生QR Code
      </el-button>
      <div slot="footer">
        <el-button
          :disabled="!canClickButton || loading"
          type="primary"
          round
          @click="print"
        >
          列印
        </el-button>
      </div>
    </el-dialog>
    <!-- 列印渲染區塊，已隱藏 -->
    <div
      ref="printPage"
      class="printPage"
    >
      <div class="QRCodecard">
        <p class="title">
          {{ communityName }}
        </p>
        <p class="subTitle">
          門禁QRcode
        </p>
        <div class="printQRcode">
          <vue-qr
            :correct-level="3"
            :dot-scale="1"
            :logo-src="require('@/assets/img/GuestPrint/sphere-logo-BW.png')"
            :text="qrcodeData"
            :logo-background-color="'#fff'"
            :logo-margin="0"
            :logo-scale="0.3"
            :logo-corner-radius="60"
            :size="500"
          />
        </div>
        <p class="timeTitle">
          訪客門禁QRcode生效期間如下
        </p>
        <div class="timeWrap">
          <div class="day">
            <div class="date">
              {{ data.startAt.slice(5,7) }}月{{ data.startAt.slice(8,10) }}日
            </div>
            <div class="time">
              {{ data.startAt.slice(11,16) }}
            </div>
          </div>
          <span>至</span>
          <div class="day">
            <div class="date">
              {{ data.dueAt.slice(5,7) }}月{{ data.dueAt.slice(8,10) }}日
            </div>
            <div class="time">
              {{ data.dueAt.slice(11,16) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      data: {
        code: '', // QRCode 資料
        guestId: '', // 訪客Id
        startAt: 'yy-mm-dd 00:00:00', // 後端紀錄時間
        dueAt: 'yy-mm-dd 00:00:00'
      },
      qrcodeData: '', // 門禁QRcodeData
      mode: 0, // 1生效、2尚未生效、3已失效
      controlCountdown: null, // 控制倒計時器
      loading: false,
      communityName: JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName,
      countdown: '', // 剩餘時間 = 倒計時時間，計算用
      showCountdown: '', // 剩餘時間 = 倒計時時間，顯示用，格式 hh:mm:ss
      canClickButton: true // 防止連點button參數
    }
  },
  beforeDestroy () {
    this.mode = 0
  },
  methods: {
    // 開啟彈窗
    openDialog (guestQRCodeData) {
      this.dialogVisible = true
      this.loading = true
      this.canClickButton = false
      this.data.code = guestQRCodeData.code
      this.data.guestId = guestQRCodeData.guestId
      this.data.startAt = this.$newFormatDate(guestQRCodeData.startAt)
      this.data.dueAt = this.$newFormatDate(guestQRCodeData.dueAt)
      if (this.data.code !== '' && this.data.startAt !== '' && this.data.dueAt !== '') { // 已經有QRCode資料
        this.qrcodeData = this.data.code
        this.judgeMode()
      // eslint-disable-next-line eqeqeq
      } else if (this.data.guestId != '') { // 沒有有QRCode資料，需重新生成
        this.reacquireQRCode()
      } else { // 沒有guestId資料，為未知錯誤
        this.dialogVisible = false
        this.$alert('發生未知錯誤', '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {}
        })
      }
    },
    // 重新取得QRCode
    async reacquireQRCode () {
      this.canClickButton = false
      clearInterval(this.controlCountdown)
      this.controlCountdown = null
      this.loading = true
      const time = await this.getNewFormTime()
      const queryPath = {
        id: this.data.guestId
      }
      const requestData = {
        startAt: `${time.startAt.replace(' ', 'T')}.000Z`,
        dueAt: `${time.dueAt.replace(' ', 'T')}.000Z`
      }
      await this.postCreateQRcode(queryPath, requestData)
    },
    // 取得現在時間，5分鐘一個級距，去掉秒數無條件進位，並回傳加減30分鐘
    // ！！注意這邊，回傳給後端的 start due 時間，需要捨棄時區影響（須為現在時間的8小時前）
    getNewFormTime () {
      return new Promise((resolve, reject) => {
        const now = new Date()
        let nowData = ''
        if (now.getMinutes() % 5 === 0) {
          nowData = `${this.$newFormatDate(now).slice(0, 17) + '00'}`
        } else {
          const interval = parseInt(now.getMinutes() / 5) + 1
          const min = interval * 5
          if (min === 60) { // 56-60分時，進位到下一個小時
            const now2 = now.getTime() + 5 * 60 * 1000
            nowData = `${this.$newFormatDate(now2).slice(0, 14) + '00:00'}`
          } else {
            nowData = `${this.$newFormatDate(now).slice(0, 14) + (('0' + (min)).slice(-2)) + ':00'}`
          }
        }
        const nowLongData = new Date(nowData).getTime()
        const newtime = {
          startAt: this.$newFormatDate(nowLongData - 30 * 60 * 1000 - 8 * 60 * 60 * 1000),
          dueAt: this.$newFormatDate(nowLongData + 30 * 60 * 1000 - 8 * 60 * 60 * 1000)
        }
        resolve(newtime)
      })
    },
    // 取得新的QRCode
    postCreateQRcode (queryPath, requestData) {
      return new Promise((resolve, reject) => {
        apiGuest.PlusGuestReservation.PostCreateQRcode(
          queryPath,
          requestData
        ).then((res) => {
          resolve()
          if (res.status === 200) {
            this.data.startAt = this.$newFormatDate(requestData.startAt)
            this.data.dueAt = this.$newFormatDate(requestData.dueAt)
            this.qrcodeData = res.data
            this.switchMode1()
            const QRcodeData = {
              code: res.data,
              startAt: requestData.startAt,
              dueAt: requestData.dueAt
            }
            this.$emit('changeqrcode', QRcodeData)
          } else {
            this.$message.error('取得QRCode失敗，請稍後再試')
            this.loading = false
            this.closeDialog()
          }
        }).catch((err) => {
          reject(err)
          this.$message.error('發生未知錯誤，請稍後再試')
          console.log('錯誤訊息：', err.response)
        }).finally(() => {
          this.canClickButton = true
          this.loading = false
        })
      })
    },
    // 判斷顯示狀態
    // 傳入格式 2021-08-08 12:12:12
    judgeMode () {
      const now = new Date()
      const startAt = new Date(this.data.startAt).getTime()
      const dueAt = new Date(this.data.dueAt).getTime()
      if (now > startAt && now < dueAt) { // 生效
        this.switchMode1()
      } else if (now < startAt) { // 尚未生效
        this.mode = 2
        setTimeout(() => {
          this.switchMode1()
        }, startAt - now)
      } else { // 失效
        this.mode = 3
      }
      this.loading = false
      this.canClickButton = true
    },
    // 切換到生效狀態
    switchMode1 () {
      console.log('切換到生效狀態')
      this.loading = false
      this.mode = 1
      this.countdown = new Date(this.data.dueAt).getTime() - new Date() // 計算剩餘生效時間
      this.countdownTimer()
      this.controlCountdown = setInterval(() => {
        this.countdownTimer()
      }, 1000)
    },
    // 倒計時器
    countdownTimer () {
      const offsetTime = this.countdown / 1000
      if (offsetTime < 0) { // 失效
        this.mode = 3
        clearInterval(this.controlCountdown)
        this.controlCountdown = null
      } else {
        const sec = ('0' + parseInt(offsetTime % 60)).slice(-2)
        const min = ('0' + parseInt((offsetTime / 60) % 60)).slice(-2)
        const hr = ('0' + parseInt(offsetTime / 60 / 60)).slice(-2)
        this.showCountdown = hr + ':' + min + ':' + sec
        this.countdown = this.countdown - 1000
      }
    },
    // 列印
    print () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.fullScreenLoading(true)
        this.$print(this.$refs.printPage)
        this.fullScreenLoading(false)
        setTimeout(() => {
          this.canClickButton = true
        }, 500)
      }
    },
    closeDialog () {
      this.dialogVisible = false
      clearInterval(this.controlCountdown)
    },
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    },
    // ------ 以下function  訪客押件和門禁卡彈窗（GuestArriveDialog.vue） 使用，皆不開啟彈窗------
    // 只列印QRCode
    onlyPrintQRcode (QRcodeData) {
      console.log('只列印QRCode', QRcodeData)
      this.qrcodeData = QRcodeData.code
      this.data.startAt = QRcodeData.startAt
      this.data.dueAt = QRcodeData.dueAt
      setTimeout(() => {
        this.$print(this.$refs.printPage)
      }, 300)
    },
    // 情境一訪客，取得新的QRCode並列印
    async creatAndPrintQRcode (guestId) {
      const time = await this.getNewFormTime()
      const queryPath = {
        id: guestId
      }
      const requestData = {
        startAt: `${time.startAt.replace(' ', 'T')}.000Z`,
        dueAt: `${time.dueAt.replace(' ', 'T')}.000Z`
      }
      await new Promise((resolve, reject) => {
        apiGuest.PlusGuestReservation.PostCreateQRcode(
          queryPath,
          requestData
        ).then((res) => {
          resolve()
          if (res.status === 200) {
            this.data.startAt = this.$newFormatDate(requestData.startAt)
            this.data.dueAt = this.$newFormatDate(requestData.dueAt)
            this.qrcodeData = res.data
          } else {
            this.$message.error('取得QRCode失敗，無法列印，訪客將直接進場')
          }
        }).catch((err) => {
          reject(err)
          console.log('錯誤訊息：', err.response)
        })
      })
      setTimeout(() => {
        this.$print(this.$refs.printPage)
      }, 300)
    }
  }
}
</script>
<style lang="sass" scoped>
#GuestQRCodeDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 540px
    .el-dialog__body
      padding-top: 24px
      padding-bottom: 15px
      .timeWrap
        .timeTitle
          color: $mainFontColor
        .mode
          margin-top: 10px
          font-size: 29px
          font-weight: bold
        .mode1
          color: #25BE00
        .mode2
          color: #999999
        .mode2_tip
          margin-top: 10px
        .mode3
          color: #999999
      .qrcodeDiv
        height: 300px
      .opacityQrcode
        opacity: 0.15
      .periodWrap
        margin-top: 4px
        margin-bottom: 24px
        .period
          font-size: 17px
          font-weight: bold
          color: $mainFontColor
          margin-top: 18px
      .el-button
        display: block
        margin: 5px auto 0px
    .el-dialog__footer
      padding: 16px
      text-align: center
  .printPage
    display: none
</style>
<style lang="scss" scoped>
@media print{
  * {
    -webkit-print-color-adjust: exact !important;
  }
  .printPage{
    display: block;
    color: $black;
    @page{
      size: A4 portrait;
    }
    .QRCodecard{
      text-align: center;
      background-color: $white;
      border: 4px $black solid;
      padding: 5%;
      .title{
        margin-top: 2%;
        font-size: 50px;
        font-weight: bold;
      }
      .subTitle{
        font-size: 25px;
        margin-top: 2%;
      }
      .printQRcode{
        padding: 5% 0;
      }
      .timeTitle{
        font-size: 30px;
        margin-top: 6%;
        margin-bottom: 3%;
      }
      .timeWrap{
        margin-top: 2%;
        border: 1px $black solid;
        border-radius: 4px;
        display: flex;
        padding: 3% 8%;
        span{
          flex: 1;
          font-size: 30px;
          padding-top: 5%;
        }
        .day{
          flex: 1;
          text-align: center;
          .date{
            font-size: 30px;
          }
          .time{
            margin-top: 8%;
            font-weight: bold;
            font-size: 50px;
          }
        }
      }
    }
  }
}
</style>
